import { toSlashedDate } from '../../../app/helper/dateFormatHelper';
import { FailedCamera } from '../../../model/failed-camera';
import {
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Tooltip,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './FailedImage.module.css';
import React from 'react';
import { FailedEventDay } from '../../../model/failed-event-day';

interface IProps {
  onClose: Function;
  cameraId?: string;
  date?: string;
  failedCamera: FailedEventDay[];
}

function FailedImageDetails({ onClose, cameraId, date, failedCamera }: IProps) {
  // Need to only fetch failed images for which we want to see the failed message
  const rows: FailedCamera[] =
    failedCamera?.filter((eventDay) => {
      return (
        toSlashedDate(eventDay?.day || '') === date &&
        eventDay?.cameras?.filter((camera) => {
          return camera.cameraId === cameraId;
        })
      );
    })[0]?.cameras || [];

  const groupByCaptureType: Map<string, FailedCamera[]> = rows?.reduce(
    (entryMap, e) =>
      entryMap.set(e.captureType, [...(entryMap.get(e.captureType) || []), e]),
    new Map()
  );

  let captureTypes: Array<string> = [];
  groupByCaptureType?.forEach((value, key) => {
    captureTypes.push(key);
  });

  return (
    <>
      <div className={styles.listHeader}>
        <Typography
          sx={{
            flex: '1 1 100%',
            textAlign: 'center',
            p: 2,
            backgroundColor: 'background.default',
          }}
          variant='h6'
          color='primary'
        >
          Failed Image Details
        </Typography>
        <Tooltip title='Close'>
          <CloseIcon
            onClick={() => onClose()}
            sx={{
              height: 32,
              width: 32,
              cursor: 'pointer',
              p: 2,
              backgroundColor: 'background.default',
            }}
            color='primary'
          />
        </Tooltip>
      </div>
      {!!groupByCaptureType && (
        <List
          sx={{
            width: '100%',
            maxWidth: 660,
            bgcolor: 'background.paper',
            position: 'relative',
            overflow: 'auto',
            maxHeight: 300,
            '& ul': { padding: 0 },
          }}
          subheader={<li />}
        >
          {!!captureTypes &&
            captureTypes.map((captureType) => (
              <li key={captureType}>
                <ul>
                  <ListSubheader
                    data-testid='capture-type'
                    sx={{ fontWeight: 'bold' }}
                  >
                    {captureType}
                  </ListSubheader>
                  {!!groupByCaptureType &&
                    groupByCaptureType?.get(captureType)?.map((item) => (
                      <ListItem
                        key={item.photoContentId}
                        sx={{ pt: 0, pb: 0, mt: 1, mb: 1 }}
                      >
                        <ListItemText
                          data-testid='failed-message'
                          className={styles.newLine}
                          primary={
                            item?.photoContentId + '\n' + item?.failedReason
                          }
                        />
                      </ListItem>
                    ))}
                </ul>
              </li>
            ))}
        </List>
      )}
    </>
  );
}

export default FailedImageDetails;
